<template>
    <div class="giveaway-page">
        <div class="adscroll-container">
            <AdScroll />
        </div>


        <header class="hero border-bottom">
            <div class="container py-5">
                <div class="hero-content text-center">
                    <h1 class="hero-title text-9 font-weight-bold mb-4 mt-2">
                        Stand A Chance To Win <span class="prize-highlight">$50 Cash!!</span>
                    </h1>
                    <p class="lead mb-0">
                        Celebrate with us and enter automatically when you buy eligible products.
                    </p>
                </div>
            </div>
        </header>

        <main class="container my-5">


            <section class="section-block section-countdown">
                <div class="section-head text-center mb-3">
                    <h2 class="h2 fw-bold mb-1 countdown-title">Win $50 Cash!!</h2>
                    <p class="mb-0 text-muted">
                        Giveaway runs from <strong class="date-highlight">1–30 September, 2025</strong>
                    </p>
                </div>

                <div class="timer-grid">
                    <div class="time-box">
                        <div class="time-num">{{ timeLeft.days }}</div>
                        <div class="time-label">DAYS</div>
                    </div>
                    <div class="time-box">
                        <div class="time-num">{{ timeLeft.hours }}</div>
                        <div class="time-label">HOURS</div>
                    </div>
                    <div class="time-box">
                        <div class="time-num">{{ timeLeft.minutes }}</div>
                        <div class="time-label">MINUTES</div>
                    </div>
                    <div class="time-box">
                        <div class="time-num">{{ timeLeft.seconds }}</div>
                        <div class="time-label">SECONDS</div>
                    </div>
                </div>

                <p class="winners-note text-center mt-3">
                    <strong>10 Lucky Winners</strong> will walk away with <strong>$50</strong> each.
                </p>
            </section>


            <section class="section-block">
                <div class="section-title-row">
                    <h2 class="h3 fw-bold mb-0">How To enter</h2>
                </div>

                <ul class="rule-list">
                    <li class="rule-item">
                        <div class="rule-left">
                        </div>
                        <div class="rule-text">
                            Buy any <strong class="brand-highlight">Magetsi</strong> product
                            <span class="text-muted">
                (ZESA tokens, NetOne Bundles, Econet Airtime &amp; Bundles, TelOne Wi-Fi, Vehicle License &amp; Insurance, Gift Cards)
              </span>
                            worth <strong class="amount-highlight">USD $5 / ZiG equivalent</strong> or more.
                        </div>
                    </li>

                    <li class="rule-item">
                        <div class="rule-left">
                        </div>
                        <div class="rule-text">
                            <strong>One product purchase for $5 / ZiG equiv = 1 entry.</strong>
                            <div class="text-muted mt-2 example-text">
                                Example: buying two ZESA tokens worth $10 (ZiG equiv) in one purchase still counts as
                                <strong>1 entry</strong>. But buying two separate products worth $5 (ZiG equiv) each
                                counts as <strong>2 entries</strong>.
                            </div>
                        </div>
                    </li>
                </ul>

                <div class="tip-banner">
                    <div class="tip-icon">
                        <svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M12 2a7 7 0 0 0-4 12c.5.5 1 1.2 1 2v1h6v-1c0-.8.5-1.5 1-2a7 7 0 0 0-4-12z"></path>
                            <path d="M9 21h6"></path>
                        </svg>
                    </div>
                    <div class="tip-text">
                        The more products you buy, the more entries you earn, and the better your chances of winning!
                    </div>
                </div>
            </section>

            <section class="section-block">
                <div class="section-title-row">
                    <h2 class="h3 fw-bold mb-0">Increase Your Chances</h2>
                </div>

                <div class="cta-grid">
                    <router-link to="/zesa" class="btn btn-primary btn-sm">
                        ZESA Tokens
                    </router-link>
                    <router-link to="/airtime/netone" class="btn btn-primary btn-sm">
                        NetOne Airtime
                    </router-link>
                    <router-link to="/airtime" class="btn btn-primary btn-sm">
                        Econet Airtime
                    </router-link>
                    <router-link to="/telone" class="btn btn-primary btn-sm">
                        TelOne Wi-Fi
                    </router-link>
                </div>

                <div class="legal-row">
                    <a href="/giveaway-terms" class="btn btn-primary btn-sm" aria-label="Giveaway Terms and Conditions">
                        <svg class="icon me-2" viewBox="0 0 24 24" aria-hidden="true">
                            <rect x="6" y="4" width="12" height="16" rx="2"/><rect x="9" y="2" width="6" height="4" rx="1"/>
                        </svg>
                        T&Cs
                    </a>

                    <span class="text-muted">
    Winners announced within <strong>10 days</strong> after the giveaway ends.
  </span>
                </div>
            </section>
        </main>
    </div>
</template>

<script>
import AdScroll from "../../core/AdScroll.vue";

export default {
    name: "TenthAnniversaryGiveaway",
    components: { AdScroll},
    metaInfo() {
        return { title: "10th Anniversary Giveaway" };
    },
    data() {
        return {
            endAt: new Date("2025-09-30T21:59:59Z"), // 23:59:59 CAT
            timeLeft: { days: "00", hours: "00", minutes: "00", seconds: "00" },
            _timer: null,
        };
    },
    mounted() {
        this.tick();
        this._timer = setInterval(this.tick, 1000);
    },
    beforeDestroy() {
        if (this._timer) clearInterval(this._timer);
    },
    methods: {
        tick() {
            const now = new Date();
            const oneDay = 24 * 60 * 60 * 1000;

            let diff = Math.max(0, this.endAt - now);

            let days = Math.floor(diff / oneDay);
            let rest = diff - days * oneDay;

            const hours = Math.floor(rest / (60 * 60 * 1000));
            rest -= hours * (60 * 60 * 1000);

            const minutes = Math.floor(rest / (60 * 1000));
            rest -= minutes * (60 * 1000);

            const seconds = Math.floor(rest / 1000);

            const displayDays = diff > 0 ? days + 1 : 0;

            this.timeLeft = {
                days: String(displayDays).padStart(2, "0"),
                hours: String(hours).padStart(2, "0"),
                minutes: String(minutes).padStart(2, "0"),
                seconds: String(seconds).padStart(2, "0"),
            };
        }
    },
};
</script>

<style scoped>



:root { --primary-color: var(--bs-primary, #0d6efd); }


.hero {
    background: hsla(0, 0%, 83%, .4);
}
.anniversary-badge {
    display: inline-flex;
    align-items: center;
    gap: .375rem;
    background: var(--primary-color);
    color: #fff;
    padding: .4rem 1rem;
    border-radius: 999px;
    font-size: .85rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .04em;
}
.hero-title {
    color: #000 !important;
    -webkit-text-fill-color: initial;
    background: none;
}
.prize-highlight,
.time-num { color: var(--primary-color); }


.section-block { margin-bottom: 2.25rem; }
.section-head { }
.section-title-row {
    display: flex; align-items: center; gap: .625rem; margin-bottom: 1rem;
}

.icon {
    width: 1.1em; height: 1.1em;
    display: inline-block;
    vertical-align: -.125em;
    stroke: currentColor;
    fill: none;
    stroke-width: 2;
}

.timer-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(120px, 1fr));
    gap: .9rem;
}
.time-box {
    background: #fff;
    border: 1px solid rgba(0,0,0,.08);
    border-radius: 12px;
    padding: 1rem;
    text-align: center;
}
.time-num { font-weight: 900; font-size: clamp(1.6rem, 3.5vw, 2rem); line-height: 1; }
.time-label { text-transform: uppercase; letter-spacing: .08em; font-size: .72rem; color: var(--bs-secondary, #6c757d); margin-top: .35rem; }
.winners-note { }


.rule-list {
    list-style: none; margin: 0; padding: 0; display: grid; gap: .75rem;
}
.rule-item {
    display: grid;
    grid-template-columns: 28px 1fr;
    gap: .75rem;
    align-items: start;
    background: #fff;
    border: 1px solid rgba(0,0,0,.08);
    border-left: 4px solid #28a745;
    border-radius: 10px;
    padding: .9rem .9rem .9rem .75rem;
}
.rule-left { display: flex; justify-content: center; padding-top: .1rem; color: var(--primary-color); }
.brand-highlight { color: var(--primary-color); }
.amount-highlight { color: var(--primary-color); }
.example-text {
    padding-left: .75rem;
    border-left: 3px solid rgba(0,0,0,.08);
}


.tip-banner {
    display: grid; grid-template-columns: 28px 1fr; gap: .75rem;
    background: var(--bs-gray-100, #f6f7f9);
    border: 1px dashed rgba(0,0,0,.12);
    border-left: 4px solid #28a745;
    border-radius: 10px;
    padding: .9rem .9rem .9rem .75rem;
    margin-top: 1rem;
}
.tip-icon { display:flex; align-items:center; justify-content:center; color: var(--primary-color); }
.tip-text { }


.cta-grid {
    display: flex;
    flex-wrap: wrap;
    gap: .75rem 1rem;
    align-items: center;
}
.cta-grid .btn {
    display: inline-flex;
    align-items: center;
    gap: .4rem;
    flex: 0 0 auto;
    width: auto;
    padding: .45rem .9rem;
    white-space: nowrap;
}

.legal-row {
    display: flex;
    align-items: center;
    gap: .75rem;
    margin-top: .75rem;
}

@media (max-width: 576px) {
    .cta-grid { gap: .6rem .75rem; }
    .legal-row {
        flex-direction: column;
        align-items: flex-start;
        gap: .5rem;
    }
}

@media (max-width: 768px) {
    .timer-grid { grid-template-columns: repeat(2, 1fr); }
}
.adscroll-container { margin: 1rem 0; }
</style>
